import React from 'react';
import PropTypes from 'prop-types';
import useTrackingHandler from '../hooks/useTrackingHandler';

const DeptLink = ({ label, hrefAttr, linkClasses }) => {
	// Explicitly pass null as the first argument to useTrackingHandler
	// to indicate we need a handler fn for a link and not an icon
	const [trackingHandler] = useTrackingHandler(null, label);

	return (
		<a className={linkClasses} href={hrefAttr} onClick={trackingHandler}>
			{label}
		</a>
	);
};

DeptLink.propTypes = {
	label: PropTypes.string.isRequired,
	hrefAttr: PropTypes.string.isRequired,
	linkClasses: PropTypes.string.isRequired
};

export default DeptLink;
